<template>
  <div>
    <slot :time="timeLeftFormatted"
          :time-value="timeLeft"
          :start="restartCountdown"
          :pause="stopCountdown"
          :proceed="startCountdown"
          :finished="timeLeft < 1"
    >
      <h5>{{  timeLeft  }}</h5>
    </slot>
  </div>

</template>

<script>
export default {
  name: "wsTimer",
  props : {
    seconds : {
      type : [String,Number],
      default : 60
    },
    startOnMount : {
      type : Boolean,
      default : true
    },
    restartTrigger : {
      type : Number,
      default : 0
    }
  },
  data() {
    return {
      timeLeft : 60,
      timerId : null,
    }
  },
  watch : {
    restartTrigger() {
      this.restartCountdown()
    },
  },
  computed : {
    timeLeftFormatted() {
      let minutes = Math.floor(this.timeLeft/60)
      let seconds = this.timeLeft%60
      minutes = minutes <10 ? ('0'+minutes) : minutes
      seconds = seconds <10 ? ('0'+seconds) : seconds

      return `${minutes}:${seconds}`
    }
  },
  methods: {
    restartCountdown(){
      this.timeLeft = this.seconds
      this.stopCountdown()
      this.startCountdown()
      this.$emit('restart')
    },
    startCountdown() {
      this.timerId = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft -= 1; // decrease time left by 1 every second
        } else {
          this.stopCountdown(); // stop the countdown when it reaches 0
          this.timerFinished(); // call the event or method that should be triggered when the timer finishes
        }
      }, 1000); // 1000 milliseconds = 1 second
    },
    stopCountdown() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.$emit('pause')
      }
    },
    timerFinished() {
      this.$emit('finish');
    },
  },
  mounted() {
    if ( this.startOnMount ) {
      this.restartCountdown()
    }
  }
}
</script>

<style scoped>

</style>